module.exports = __webpack_public_path__ + "static/media/supolabs.8c73f34b.webp";